import { useAppContext } from '../../../../system/providers/appContextProvider';
import { useUserContext } from '../../../../system/providers/userContextProvider';
import { TextInput } from '../../../../components/controls/inputs';
import { PluginWrapper } from '../../../../components/plugins';
import { Button } from '../../../../components/buttons/button';
import { useState } from 'react';
import { IPluginSettingTypeCreateDTO, IPluginSettingTypeUpdateDTO } from '../../../../libs/coreapi-dto/service/pluginSettingType';


export const CreateDefaultPluginSettingsView = () => {
    const appContext = useAppContext();
    const userCtx = useUserContext();

    const [value, setValue] = useState<string>(userCtx.userName);

    const roles = userCtx.userRoles.flat?.() ?? userCtx.userRoles;
    const isAdministrator = roles.includes('Administrator');


    const save = () => {
        appContext.uiApiService.uiDefaultPluginSettingsRequest.getByName(value, (response) => {

            if (response.respType == 'isCompleted') {
                if (response.data?.idGlobal) {
                    const model = {
                        idUserGlobal: userCtx.idGlobal,
                        idPluginSettingTypeGlobal: response.data.idGlobal
                    } as IPluginSettingTypeUpdateDTO

                    appContext.uiApiService.uiDefaultPluginSettingsRequest.update(model)
                }
            }
            else {
                const model = {
                    idUserGlobal: userCtx.idGlobal,
                    name: value
                } as IPluginSettingTypeCreateDTO
                appContext.uiApiService.uiDefaultPluginSettingsRequest.create(model)
            }
        })
    }

    return (
          <PluginWrapper>
            <TextInput
                inline
                value={value}
                label={'Наименование настройки'}
                onChange={setValue}
            />
            <Button disabled={!isAdministrator} variant="primary" onClick={save}>{'Сохранить'}</Button>
        </PluginWrapper>
        
    )
}